import { Dispatch, SetStateAction } from 'react'

import {
  WIDGET_DISPLAY_LOGIC_CHOICES,
  WIDGET_SEARCH_CONDITION_CLEAR,
  WidgetSearchCondition
} from '@/common/app/modules/recommend/widget'
import { WidgetContentType } from '@/common/model/recommend/widget'

import Button from '@/components/view/atoms/button/Button'
import GroupButton from '@/components/view/atoms/button/GroupButton'
import Selector, { SelectorSize, SelectorType } from '@/components/view/atoms/selector/Selector'
import SearchConditionAreaContent from '@/components/view/layouts/area/SearchConditionAreaContent'
import SortButtonList from '@/components/view/layouts/button/SortButtonList'
import FormRow from '@/components/view/layouts/form/FormRow'

// コンテンツタイプは GroupButton（label/value）で表示する
const CONTENT_TYPE_GROUP_CHOICES = [
  { label: 'すべて', value: '' },
  { label: '商品レコメンド', value: WidgetContentType.PRODUCT },
  { label: '記事レコメンド', value: WidgetContentType.ARTICLE }
]

// レコメンドロジックは Selector（プルダウン）で表示する
const DISPLAY_LOGIC_CHOICES = [{ name: 'すべて', value: '' }, ...WIDGET_DISPLAY_LOGIC_CHOICES]

interface Props {
  condition: WidgetSearchCondition
  setCondition: Dispatch<SetStateAction<WidgetSearchCondition>>
}

const WidgetSearchConditionField = ({ condition, setCondition }: Props) => {
  const isDefault = condition.contentType === '' && condition.displayLogic === ''

  return (
    <SearchConditionAreaContent>
      <FormRow gap={12} align='center'>
        <GroupButton
          choices={CONTENT_TYPE_GROUP_CHOICES}
          value={condition.contentType}
          onSelect={(value) =>
            setCondition((c) => ({
              ...c,
              contentType: value as WidgetSearchCondition['contentType']
            }))
          }
        />
        <Selector
          name='displayLogic'
          size={SelectorSize.AUTO}
          selectorType={SelectorType.SECONDARY}
          value={condition.displayLogic}
          choices={DISPLAY_LOGIC_CHOICES}
          onChange={(e) =>
            setCondition((c) => ({
              ...c,
              displayLogic: e.target.value as WidgetSearchCondition['displayLogic']
            }))
          }
        />
      </FormRow>
    </SearchConditionAreaContent>
  )
}

export default WidgetSearchConditionField
